export const RECOMMERCE_PAGES = ['product', 'variant']

export const PAYMENT_METHODS_SLUG = 'payment-methods'
export const ABOUT_US_URL = 'https://company.recharge.com/'
export const POPULAR_PRODUCTS_SLUG = 'popular-products'
